import React from 'react';
import PropTypes from 'prop-types';
import { Paragraph, Heading } from 'components';
import './Step.scss';

const Step = ({ number, step, details }) => (
  <div className={'step__container'}>
    <Heading size={'regular'} type={3} additionalClass={'step__number'}>
      {number}
    </Heading>
    <Heading size={'regular'} type={3} additionalClass={'step__heading'}>
      {step}
    </Heading>
    <Paragraph size={'small'} additionalClass={'step__text'}>
      {details}
    </Paragraph>
  </div>
);

Step.propTypes = {
  number: PropTypes.string,
  step: PropTypes.string,
  details: PropTypes.string,
};

export default Step;
